import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../button';
import { CrossIcon, MagnifyingGlassIcon } from '../icons';
import { Input } from './input';
const searchIconSizeMap = {
    h28: 16,
    h32: 16,
    h36: 16,
    h40: 16,
    h50: 18,
    s: 18,
    m: 20,
    l: 24,
};
export const SearchInput = ({ size = 'm', value, placeholder, disabled, className, onChange, ...inputProps }) => {
    const inputRef = React.useRef(null);
    const handleClear = () => {
        const input = inputRef.current;
        if (!input) {
            return;
        }
        // Clear through the native value setter so React's controlled-input value
        // tracker registers the change, then dispatch a native input event so the
        // consumer's onChange fires with the cleared value (event.target.value === '').
        const nativeValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
        nativeValueSetter?.call(input, '');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
    };
    return (_jsx(Input, { ref: inputRef, className: className, value: value, placeholder: placeholder, disabled: disabled, startContent: _jsx(MagnifyingGlassIcon, { size: searchIconSizeMap[size] }), endContent: value ? (_jsx(Button, { iconLeft: _jsx(CrossIcon, {}), onClick: handleClear, variant: "ghost", size: "xxs" })) : undefined, onChange: onChange, withStartSeparator: false, size: size, ...inputProps }));
};
//# sourceMappingURL=search-input.js.map